// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8fde9770","453":"155624ff","667":"c300d1e9","977":"4e5dd2c4"}[chunkId] + ".chunk.js";
};